import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../style/HeroSection.scss";

const HeroSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const texts = ["brands", "web design", "social media", "your business"];

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % texts.length);
    }, 2000); // Change every 2 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="hero-section1">
      <div className="content-hero-section1">
            <h1 className="title-hero">
        Creative digital solutions
        <span className="cube-container">
          for&nbsp;
          {texts.map((text, index) => (
            <span
              key={index}
              className={`cube-span ${index === activeIndex ? "active" : ""}`}
            >
              {text}
            </span>
          ))}
        </span>
      </h1>
        <div className="content-paragraph">
        <p className="p-hero">
  At <span>Evas</span>, we help you create your website, grow your brand, and stand out online with design, social media, and creative content — all in one place.
</p>
        </div>
        <div className="buttons">
        <Link to="/contact" >
          <button className="primary-btn">Get in Touch</button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
